import { APIRule, RuleDataProps, RuleSession, RuleSettings } from "../types";

function rulesArrayFrom(input: any): any[] {
    if (Array.isArray(input)) return input;
    if (input && Array.isArray(input.data)) return input.data;
    return [];
  }
export default function parseRulesToSettings(rules: APIRule[] | { data?: RuleDataProps[] }, base: RuleSettings): RuleSettings {
    const out: RuleSettings = { ...base };
    const arr = rulesArrayFrom(rules);
    const byName = (needle: string) => arr.find((r: RuleDataProps) => r.name.toLowerCase().includes(needle.toLowerCase()));
    const maxRisk = byName("Max Risk");
    if (maxRisk?.condition?.max_risk_percent != null) out.maxRiskPercent = Number(maxRisk.condition.max_risk_percent);
    const noOver = byName("No Overtrade");
    if (noOver?.condition?.max_positions != null) out.maxPositions = Number(noOver.condition.max_positions);
    if (noOver?.condition?.max_lots_per_trade != null) out.maxLotsPerTrade = Number(noOver.condition.max_lots_per_trade);
    const maxSL = byName("Max SL");
    if (maxSL?.condition?.max_sl_percent != null) out.maxSLPercent = Number(maxSL.condition.max_sl_percent);
    const maxDD = byName("Max Daily DD");
    if (maxDD?.condition?.max_dd_percent != null) out.maxDailyDDPercent = Number(maxDD.condition.max_dd_percent);
    const rr = byName("RR Target Declared");
    if (rr?.condition?.min_rr_allowed != null) out.minRRAllowed = Number(rr.condition.min_rr_allowed);
    const sessions = byName("Allowed Trading Sessions");
    if (sessions?.condition?.allowed_sessions) out.allowedSessions = sessions.condition.allowed_sessions as RuleSession[];
    if (sessions?.condition?.violate_outside_session != null) out.violateOutsideSession = !!sessions.condition.violate_outside_session;
    const first = byName("First Trade Must Have Goal");
    if (first?.condition?.require_first_trade_goal != null) out.requireFirstTradeGoal = !!first.condition.require_first_trade_goal;
    const change = byName("Max SL/TP Change");
    if (change?.condition?.max_sl_tp_change_percent != null) out.maxSLTPChangePercent = Number(change.condition.max_sl_tp_change_percent);
    return out;
  }